var QuestExt = new Class({
  Extends: Quest,

  options: {
    cls: "w_miniquest",
    redirect: true,
    element_to_replace: null, //if redirect is false, replaces this element with new html
    submit_delay: 500,
    multiselect_suspension_points: false,
    type: null,
    data: null,
    results_suffix: '',
    auto_open: false
  },

  initialize: function(element, options) {
    this.setOptions(options);
    this._element = element;

    if(this._element) {
      this.build();
    }
  },

  build: function(){
    var self = this,
        _self = this._element,
        opts = this.options,
        cls = opts.cls;

    this._form = _self.getElement('form') || _self;

    this.search_term_support();

    this._form_results = _self.getElement('.' + cls + '_results') || new Element('div');
    this._form_matches = _self.getElement('.' + cls + '_results_matches') || new Element('div');

    this._veil = this._form_results.getElement('.veil') || new Element('div');

    this._messages = this._form.getElements('.message');

    this._sort_select = document.getElement('.w_styled_select._sort select');

    this._submitter = _self.getElement('.w_miniquest_results .submitter');

    if(this._submitter){
      this._submitter.addEvent('click', function(e){
          if (self._submitter.hasClass('_no_results')) {
              return;
          }
        //self.fireEvent('submitterClick');
      	var results_url = this._form.get('data-results-url');
      	var _body = document.getElement('body');

        if(e && e.stop) e.stop();

        //note: if the rpc that save the data in the session is finished before clicking the submit,
		// redirect the page to the results page right away instead of redirecting to the buy/rent page.
		// this way, we can load the results more faster.
		// these changes are applied to buy/rent page only for now.

        if(opts.redirect){
        	if(_body.get('id') == 'srb' || _body.get('id') == 'srr'){
	        	if((this.request && this.request.isRunning()) || !results_url){
	          		this._form.submit();
	        	}
	        	else{
					location.href = results_url;
	        	}
	        }
	        else{
	        	this._form.submit();
	        }
        }else{
          this.get_results();
        }

        Cookie.write('sr_lat', null);
        Cookie.write('sr_lng', null);
        Cookie.write('crSearchScrollPosition', 0);

        this.multiselects.each(function(el){
          el.close_list();
        });
      }.bind(this));
    }

    this.build_date_switchers();
    this.build_date_pickers();

    var _selects = this._form.getElements('select');

    if(_selects){
      _selects.addEvent('change', this.submit.bind(this));
    }

    var _multiselects = this._element.getElements('.w_multiselect');
    this.multiselects = [];

    _multiselects.each(function(_el){
    	var ms;

      if(_el.hasClass('regions')){
        ms = new MultiselectExt(_el, {
          suspension_points: opts.multiselect_suspension_points,

          onOpenList: function(){
          	self.fireEvent('regionsListOpen');
          },

          onCloseList: function(){
          	self.fireEvent('regionsListClose');
          }
        });
      }else{
        ms = new Multiselect(_el, {
          text_input: false,
          close_button: false,
          equality: true,
          add_tiles: false
        });
      }

      ms.addEvents({
        'change': function(){
          this.submit();

          if(_el.hasClass('_beds')){
          	self.fireEvent('filterClicked');
          }

          self.fireEvent('multiselectChange');
        }.bind(this),

        'allSelected': function(){
          var _chs = _el.getElements('[type="checkbox"]');

          _chs.each(function(_el){
            _el.checked = false;
          });
        }.bind(this),

        'openList': function(){
          self.fireEvent('multiselectOpenList');
        },

        'closeList': function(){
          self.fireEvent('multiselectCloseList');
        }
      });

      this.multiselects.push(ms);
    }.bind(this));

    var _selects = this._form.getElements('select');

    if(_selects){
      _selects.addEvents({
      	'change' : function(){
      		self.submit();

      		self.fireEvent('filterClicked');
		    }
		  })
	  }

    this.built = true;
    this.submit();

    this._form.removeEvents();
    this._element.show();
    this.build_sliders();

    this.add_events_to_other_form_elements();

    if(this._element.hasClass('_small')){
      this.add_tools_toggle();
    }
    this._reset = new Element('span', {'class': 'w_miniquest_reset', 'html': '<i class="fa fa-repeat"></i><span>Clear Search Options</span>'}).inject(this._submitter, 'after');

    this._reset.addEvent('click', function(){
      self.reset();
    });


    this.add_message();

   	this.add_subneighborhoods_support();

  },

  build_sliders: function(){
  	var self = this;
    var _price_slider = this._element.getElement('.price_slider');

		if(Cookie.read('LsrSearchFilter')){
			this.cookies = JSONMOO.decode(Cookie.read('LsrSearchFilter'), false);
		}

    this.price_slider = new Rangeslider(_price_slider, {
      title: 'Price Range:',
      min: this.cookies? this.cookies.min : null,
			max: this.cookies? this.cookies.max : null,
      onComplete: function(){
      	self.submit();

      	self.fireEvent('filterClicked');
      },
      type: this.options.rangeslider_type,
      reset_initialy: this.options.reset_initialy
    });
  },

  add_tools_toggle: function(){
    var _shrinker_head = this._element.getElement('.advanced_tools_toggle');
    var _advanced_tools = this._element.getElement('.advanced_tools');

    if(!_shrinker_head) return;

    this.shrinker = new Shrinker(_advanced_tools, {
      min_height: 0,
      toggler: _shrinker_head,
      single_opened: false,
      onShrink: function(){
        this._toggler.set('html', '+');
      },

      onUnshrink: function(){
        this._toggler.set('html', '-');
      }
    });

    if(this.options.auto_open){
    	_shrinker_head.fireEvent('click');
    }
  },

  close_advanced_tools: function(){
    if(this.opener){
      var animate = this.opener.options.animate;
      this.opener.options.animate = false;
      this.opener.close_cnt();
      this.opener.options.animate = animate;
    }
  },

  handle_form_request: function(){
    this._form_matches.set('text', '...');
    this._element.addClass('_loading');
    this.animate_results();
  },

  handle_form_success: function(data){
    this._element.removeClass('_loading');
    this.stop_animate_results();
    this.set_matches(data.results);
    this.data = data;

    if(data.results > 0){
      if(this.options.redirect){
        this._form.addClass('has_results');
      }else{
        if(this.not_first_time){
          this._form.addClass('has_results');
        }
      }
    	this.fireEvent('hasResults');
    }else{
      this._form.removeClass('has_results');
      this.fireEvent('noResults');
    }

    this.not_first_time = true;

    this.fireEvent('dataChange', [data.results]);
  },

  animate_results: function(){
    this._form_matches.removeClass('_small');
    this._form_matches.removeClass('_supersmall');

    this.current_animate_num = this._form_matches.get('text').toInt() || Number.random(1000, 4000);
    this.stop_animate_results();
    this.animate_interval_id = this.run_animate_results.periodical(1, this);
  },

  set_matches: function(matches){
    var m = ((matches<100000)? Core.add_commas(matches) : '+100,000');
    this._form_matches.set('html', m + this.options.results_suffix);

    this._form_matches.addClass(((matches > 9999)? '_small' : ''));
    this._form_matches.addClass(((matches > 99999)? '_supersmall' : ''));
  },

  get_results: function(){
    var self = this;
    var _element = this.options.element_to_replace;

    this.multiselects.each(function(el){
      if(!el._element.hasClass('regions')){
        el.close_list();
      }
    });

    this._form.removeClass('has_results');

    if(!_element) return;

    this._veil.show();

    //keep the sorting
    var url = this._form.get('action');
    if(this._sort_select && this._sort_select.getStyle('display') != 'none' && this._sort_select.getElement(':selected')){
    	var href = this._sort_select.getElement(':selected').get('data-href');
    	var param = href.split('&sort=')[1];
    	url += '?sort=' + param + '&lazy=true';
    }
    else{
    	url += '?lazy=true';
    }

    new Remote({
      rpc: url,
      data: '&' + this._form.toQueryString().trim() + '&ajax=1',
      onSuccess: function(){
        var data = this.get_data();

        if(!data || !data.content || data.content == ''){
          _element.set('html', '<div class="w_message _info clearfix"><span>No listings found at this time.</span></div>');
          self._veil.hide();
          self.fireEvent('getResults', [data.content]);

          return;
        }

        _element.set('html', data.content);

        new Multisortable(_element.getElement('.w_multisortable'), {
					divtable_zebra_order: 'odd'
				});

        new StyledSelect(_element.getElement('.w_styled_select'));

        self._veil.hide();

        //Core.add_gallery_support(_element.getElement('.w_multisortable'));
        Core.add_pricehistory_support(_element.getElement('.w_multisortable'));
        Core.add_video_popups_support(_element);
        Core.add_blimp_forms();

		    self.search_term_support();
        self.fireEvent('getResults', [data.content]);
      }
    });
  },

  reset: function(){
  	this._text_inputs.each(function(_el){
    	_el.set('value', '');
    });

    var _regions = this._element.getElement('.w_multiselect.regions');

    if(_regions){
      var _monitor_elements = _regions.getElements('.monitor_element');

      if(_monitor_elements.length > 0 ){
        _monitor_elements.each(function(_el){
        	_el._parent.fireEvent('click');
        })
      }
    }

    var _beds = this._element.getElement('.beds_li');

    if(_beds){
      _beds.getElements('li._selected').each(function(_el){
        _el.fireEvent('click');
      });
    }

    var _switch_to_date_updated = this._element.getElement('.switch_to_date_updated');

    if(_switch_to_date_updated){
      _switch_to_date_updated.fireEvent('click');
    }

    var _styled_selects = this._element.getElements('.w_styled_select');

    _styled_selects.each(function(_el){
    	var ind = 0;

    	if(_el.getParent('.doorman_li')){
    		ind = 2; // 'not important' option
    	}

      _el.getElements('li.option')[ind].fireEvent('click');
    })

    var _styled_checkboxes = this._element.getElements('.w_styled_checkbox');

    _styled_checkboxes.each(function(_el){
      if(_el.getElement('input').checked){
        _el.fireEvent('click');
      }
    });

    this.price_slider.reset();
  },


  search_term_support: function(){
  	var _input = this._form.getElement('[name="FormSearchListings[search_term]"]');

  	if(!_input || _input.get('value') == '') return;

  	if(this._form.getParent('.w_side_search')){
  		_input.set('value', '');
  	}else{
  		var val = _input.get('value');

  		if(val.length > 10){
  			val = val.substring(0, 10) + '...';
  		}

  		var _cont = document.getElement('.w_multisortable .sort_tools') || document.getElement('.page_title h1');

  		if(_cont.getElement('.search_term_toggle')) return;

  		var _term = new Element('.search_term_toggle', {
  			'html': 'Search results for \'' + val + '\'<span>&nbsp;</span>'
  		});

  		_term.inject(_cont);

  		var self = this;

  		_term.getElement('span').addEvents({
  			'click': function(){
  				_input.set('value', '');
  				_term.dispose();

  				var __get_results = function(){
  					self._submitter.fireEvent('click');
  					self.removeEvent('dataChange', __get_results);
  				}

  				self.addEvent('dataChange', __get_results);

  				self.submit();
  			}
  		});
  	}
  },

  add_message: function(){
		var _filter_message = this._filter_message = this._form.getElement('.filter_message');

		if(!_filter_message) return;

		_filter_message.addEvent('click', function(){
			_filter_message.dispose();

			Cookie.write('crLsrFilterMessageClosed', true);
		});
	},

	add_subneighborhoods_support: function(){
		var _sn = this._element.getElements('.sub_neighborhoods :checked');

		if(!this._element.hasClass('_small')){
			_sn.each(function(_el){
				_el.checked = false;
			});

			return;
		}

		var _labels_cont = new Element('.sub_neighborhoods_labels').inject(document.getElement('.content_main'), 'top');

		_sn.each(function(_el){
			var _label = _el.getNext('label');

			if(!_label) return;

			_label.addClass('search_term_toggle')
						.adopt(new Element('span'))
						.inject(_labels_cont);

			_label.addEvent('click', function(){
				_label.inject(_el, 'after');
			});
		});
	}
});
